export default __webpack_public_path__ + "static/media/payporteLogo.b1186bde.jpg";